import config from "config";
import API from "./http";

const restrictions = {
  async all(limit = 50, page = 1) {
    try {
      const params = {
        limit,
        page
      };

      const res = await API.get(`${config.CORP_API_URL}/restrictions`, {
        params
      });

      return res.data;
    } catch (err) {
      console.error("Error getting all restrictions", err);
      throw err;
    }
  },
  async get(id) {
    try {
      const res = await API.get(`${config.CORP_API_URL}/restriction/${id}`);
      return res.data;
    } catch (err) {
      console.error(`Error getting restriction ${id}`, err);
      throw err;
    }
  },
  async update(id, data) {
    try {
      const res = await API.put(`${config.CORP_API_URL}/restriction/${id}`, data);
      return res.data;
    } catch (err) {
      console.error(`Error updating restriction ${id}`, err);
      throw err;
    }
  },
  async create(data) {
    try {
      const res = await API.post(`${config.CORP_API_URL}/restrictions`, data);
      return res.data;
    } catch (err) {
      console.error("Error creating a restrictions", err);
      throw err;
    }
  }
};

export const frequencyTitles = {
  DAILY: "Diária",
  WEEKLY: "Semanal",
  MONTHLY: "Mensal"
};

export const Frequency = {
  DAILY: "DAILY",
  WEEKLY: "WEEKLY",
  MONTHLY: "MONTLY"
};

export default restrictions;
